/* global__DEBUG__:false, __FORCE_CAPTIONS__:false */
/* eslint-disable no-unused-vars */

/*
 * We need the PIXI and P2 import so disabling no-unused-vars
 */

import './../scss/game.scss';
import { Application, Debugger } from 'springroll';
import PIXI from 'expose-loader?PIXI!phaser-ce/build/custom/pixi.js';
import p2 from 'expose-loader?p2!phaser-ce/build/custom/p2.js';
import Phaser from 'expose-loader?Phaser!phaser-ce/build/custom/phaser-split.js';
import App from './App';
import * as Const from 'app/constants/AppConstants';
import 'utils/resetTransform-polyfill';
import { GoogleAnalytics } from 'springroll-google-analytics-plugin';
import { LoggingPanel } from 'springroll-logging-panel-plugin';

const checkExists = (lib, id) => {
  if (typeof lib === 'undefined') {
    console.error('Library Missing :\t', id);
  } else {
    console.info('Library Exist :\t', id);
  }
};

checkExists(PIXI, 'PIXI');
checkExists(p2, 'p2');
checkExists(Phaser, 'Phaser');

window.PhaserGlobal = { hideBanner: true };

const parent = document.getElementById(Const.GAME_DIV_ID);
parent.className = Const.GAME_DIV_CLASSNAME;

// Phaser.Device.whenReady(() => {
//   new App({ renderMode: Phaser.AUTO });
// });

Debugger.minLevel('GENERAL');
Debugger.enable(__DEBUG__);
if (__DEBUG__) {
  Application.uses(new LoggingPanel());
}
Application.uses(new GoogleAnalytics());

// Create a new SpringRoll application.
const application = new Application({
  features: {
    captions: true,
    vo: true,
    music: true,
    sfx: true,
  },
});

const app = new App();
// Listen for when the application is ready.
application.state.ready.subscribe((isReady) => {
  if (isReady) {
    app.init(application);
  }
});

// Hook up audio controls to manager objects.
application.state.pause.subscribe((result) => {
  if (app.game) {
    app.pauseGame(result);
  }
});
application.state.captionsMuted.subscribe((result) => {
  if (__FORCE_CAPTIONS__) {
    result = false;
  }
  if (app.game && app.game.springRollCaptionsPlugin) {
    app.game.springRollCaptionsPlugin.setMute(result);
  }
});
application.state.soundVolume.subscribe((result) => {
  if (app.game && app.game.sounds) {
    app.game.sounds.soundVolume = result;
  }
});
application.state.voVolume.subscribe((result) => {
  if (app.game && app.game.sounds) {
    app.game.sounds.voVolume = result;
  }
});
application.state.musicVolume.subscribe((result) => {
  if (app.game && app.game.sounds) {
    app.game.sounds.musicVolume = result;
  }
});
application.state.sfxVolume.subscribe((result) => {
  if (app.game && app.game.sounds) {
    app.game.sounds.sfxVolume = result;
  }
});

export default application;
